export default __webpack_public_path__ + "static/media/erc1400.e0072205.svg";